import { render } from "./TopComp.vue?vue&type=template&id=39088f23&scoped=true"
import script from "./TopComp.vue?vue&type=script&lang=js"
export * from "./TopComp.vue?vue&type=script&lang=js"

import "./TopComp.vue?vue&type=style&index=0&id=39088f23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39088f23"]])

export default __exports__